module.exports = __webpack_public_path__ + "static/media/add-circle.87fee8b8.svg";